import { CTAButton } from './page-header/page-header.component';

const NAVIGATION_TO_HASH: Record<string, string> = {
  homepage: '#home',
  'express-washes': '#express-wash-packages',
  'express-detail': '#express-auto-details',
  fleets: '#fleet-management',
  coupons: '#coupons'
};

export function resolveHeaderCtaLink(cta: {
  link?: string;
  buttonNavigation?: string;
} | null | undefined): string {
  if (!cta) {
    return '#express-wash-packages';
  }

  if (cta.buttonNavigation && NAVIGATION_TO_HASH[cta.buttonNavigation]) {
    return NAVIGATION_TO_HASH[cta.buttonNavigation];
  }

  if (cta.link && cta.link !== '#') {
    return cta.link;
  }

  return '#express-wash-packages';
}

export function buildHeaderCtaButton(cta: any): CTAButton {
  return {
    text: cta?.text || cta?.label || 'Book Wash',
    link: resolveHeaderCtaLink(cta),
    buttonNavigation: cta?.buttonNavigation,
    backgroundColor: cta?.backgroundColor || '#1B5BFF',
    textColor: cta?.textColor || '#FFFFFF'
  };
}
